import React from "react";
import "./dateSelector.css";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import { createTheme, FormControl, ThemeProvider } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

import { useTheme } from "../../../contexts/ThemeContext";

const DateSelector = React.forwardRef((props, ref) => {
  const { theme } = useTheme();

  const { dRef, mRef, yRef } = ref ? ref : { dRef: {}, yRef: {}, mRef: {} };
  // const [date, setDate] = useState({
  //     day: '',
  //     month: '',
  //     year: ''
  // })

  // const yearRef = useRef()

  // function handleDateChange(e){
  //     setDate(prev => {
  //         return {
  //             ...prev,
  //             [e.target.name]: e.target.value
  //         }
  //     })
  // }

  let year, month, day;
  if (props.defaultValue) {
    [day, month, year] = props.defaultValue.split("/").map((n) => parseInt(n));
  }

  const styles = () => {
    let mt = "80px";
    if (props.gap) {
      mt = props.gap;
    }

    let w = "100%";
    if (props.width) {
      w = props.width;
    }

    return {
      marginTop: mt,
      width: w,
    };
  };

  const Mtheme = createTheme({
    direction: "rtl",
  });

  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  const dayItems = Array(31)
    .fill(0)
    .map((_, index) => {
      return (
        <MenuItem key={index} value={index + 1}>
          {index + 1}
        </MenuItem>
      );
    });

  const months = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const monthItems = months.map((value, idx) => {
    return (
      <MenuItem key={value} value={idx + 1}>
        {value}
      </MenuItem>
    );
  });

  const currentDate = new Date().toLocaleDateString("fa-IR-u-nu-latn");
  const thisYear = parseInt(currentDate.split("/")[0]);

  const yearItems = Array(100)
    .fill()
    .map((_, idx) => thisYear - idx)
    .map((val) => (
      <MenuItem value={val} key={val}>
        {val}
      </MenuItem>
    ));

  return (
    <div className="date-picker-container" style={styles()}>
      <span className="date-picker-title">تاریخ تولد :</span>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={Mtheme}>
          <FormControl
            variant="standard"
            fullWidth
            className="form-date-selector"
          >
            <InputLabel id="select-label-year">سال</InputLabel>
            <Select
              labelId="select-label-year"
              id="select-year"
              label="Year"
              defaultValue={year ? year : ""}
              inputRef={ref ? yRef : ""}
              disabled={props.disabled ? props.disabled : false}
              MenuProps={{
                className: `drop-menu ${theme === "light" ? "light-drop" : ""}`,
              }}
              IconComponent={() => (
                <FontAwesomeIcon icon={faChevronDown} color="#6b6b6b" />
              )}
            >
              {yearItems}
            </Select>
          </FormControl>
          <FormControl
            variant="standard"
            fullWidth
            className="form-date-selector"
          >
            <InputLabel id="select-label-month">ماه</InputLabel>
            <Select
              labelId="select-label-month"
              id="select-month"
              label="Month"
              inputRef={ref ? mRef : ""}
              defaultValue={month ? month : ""}
              disabled={props.disabled ? props.disabled : false}
              MenuProps={{
                className: `drop-menu ${theme === "light" ? "light-drop" : ""}`,
              }}
              IconComponent={() => (
                <FontAwesomeIcon icon={faChevronDown} color="#6b6b6b" />
              )}
            >
              {monthItems}
            </Select>
          </FormControl>
          <FormControl
            variant="standard"
            fullWidth
            className="form-date-selector"
          >
            <InputLabel id="select-label-day">روز</InputLabel>
            <Select
              labelId="select-label-day"
              id="select-day"
              label="Day"
              inputRef={ref ? dRef : ""}
              defaultValue={day ? day : ""}
              disabled={props.disabled ? props.disabled : false}
              MenuProps={{
                className: `drop-menu ${theme === "light" ? "light-drop" : ""}`,
              }}
              IconComponent={() => (
                <FontAwesomeIcon icon={faChevronDown} color="#6b6b6b" />
              )}
            >
              {dayItems}
            </Select>
          </FormControl>
        </ThemeProvider>
      </CacheProvider>
    </div>
  );
});

export default DateSelector;
